import { useMemo } from "react";
import { FormField } from "../FormField";
import { TagsField } from "../TagsField";
import { useAssignableEmployeesQuery } from "../../api/queries/employees";
import { PRIORITIES } from "../../utils/constants";

const TASK_PRIORITY_OPTIONS = Object.entries(PRIORITIES).map(([k, v]) => ({
  value: k,
  label: v.label,
}));

export default function TaskNodeFields({ node, readOnly = false, onChange }) {
  const updateField = (field, value) => onChange({ ...node, [field]: value });

  const { data: assignable = [] } = useAssignableEmployeesQuery();

  const assigneeOptions = useMemo(
    () => [
      { value: "", label: "- Выберите исполнителя -" },
      ...assignable.map((e) => ({
        value: e.id,
        label: `${e.last} ${e.first}`,
      })),
    ],
    [assignable],
  );

  const tagsValue =
    node.tagsInput !== undefined
      ? node.tagsInput
      : Array.isArray(node.tags)
        ? node.tags.join(", ")
        : "";

  return (
    <div className="project-info-fields">
      <FormField
        label="Название"
        value={node.title ?? ""}
        onChange={(v) => updateField("title", v)}
        disabled={readOnly}
        inline
      />

      <div className="fields-row fields-row--stacked">
        <div className="field-row">
          <label className="field-label">Описание</label>
          <div className="flex-1">
            <textarea
              className="inp"
              rows={2}
              value={node.desc ?? ""}
              onChange={(e) => updateField("desc", e.target.value)}
              disabled={readOnly}
            />
          </div>
        </div>
      </div>

      <TagsField
        value={tagsValue}
        onChange={(raw) => onChange({ ...node, tagsInput: raw })}
        disabled={readOnly}
      />

      <div className="fields-row">
        <FormField
          label="Исполнитель"
          type="select"
          options={assigneeOptions}
          value={node.assigneeId ?? ""}
          onChange={(v) => updateField("assigneeId", v)}
          disabled={readOnly}
          inline
        />
        <FormField
          label="Плановые часы"
          type="number"
          min="0.5"
          step="0.5"
          value={node.plannedHours ?? ""}
          onChange={(v) => updateField("plannedHours", v)}
          disabled={readOnly}
          inline
        />
      </div>

      <div className="fields-row">
        <FormField
          label="Приоритет"
          type="select"
          options={TASK_PRIORITY_OPTIONS}
          value={node.priority ?? ""}
          onChange={(v) => updateField("priority", v)}
          disabled={readOnly}
          inline
        />
      </div>
    </div>
  );
}
